import { Category } from "@hapi.one/core-cli";

export const categoryOptions = Object.keys(Category).filter((v) => isNaN(+v));

export const timeOutTimeAmount = 4000;

export const EMPTY_TABLE_COL = "";
